var map = {
	"./components/aggregated-health-states/AggregatedHealthStates.global.vue": "9287",
	"./components/alerts/Alerts.global.vue": "fd5a",
	"./components/consumption-chart/ConsumptionChart.global.vue": "28e4",
	"./components/widget-list/WidgetList.global.vue": "ea2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "67a2";
module.exports = webpackContext;